<template>
  <div class="row">
    <div class="col-md-12">
      <card>
        <ticket-head :ticket="ticket"
                     :status="status"
                     :isAuthor="isAuthor"
                     @update="updateTicket"></ticket-head>
        <buttons-block
          :ticket="ticket"
          :status="status"
          :isAuthor="isAuthor"
          @update="updateTicket"></buttons-block>
        <div class="row">
          <div class="col-md-12 col-lg-6">
            <ticket-body
              :ticket="ticket"
              :finalDate="finalDate"
              :isAuthor="isAuthor"
              :employees="employees"
              @save="save"
              @update="updateTicket"></ticket-body>
          </div>
          <div class="col-md-12 col-lg-6">
            <comments-layout :comments="comments"
                             :employees="employees"
                             :employee_id="myEmployeeId"
                             :ticket_id="ticket['ticket_id']"
                             @add-comment="addComment"></comments-layout>
          </div>
        </div>
      </card>
    </div>
  </div>
</template>

<script>
    import axios from "axios";
    import {getCookie, setCookie, url} from "../../plugins/axios";
    import NotificationTemplate from "../Notifications/NotificationTemplate";
    import ButtonsBlock from "./ButtonsBlock";
    import TicketHead from "./TicketHead";
    import TicketBody from "./TicketBody";
    import CommentsLayout from "../Comments/CommentsLayout";

    export default {
      name: "TicketDetails",
      components: {CommentsLayout, TicketBody, TicketHead, ButtonsBlock},
      data(){
        return{
          myEmployeeId: parseInt(getCookie('Employee-id')),
          status : "success",
          ticket: {
            ticket_id: 0,
            title: "",
            text: "",
            employee_id_from: this.myEmployeeId,
            employee_id_to: 0,
            beginning_date: this.getCurrentTime(),
            ending_date: null,
            done_before: null,
            is_read_from: true,
            is_read_to: false,
            priority: "normal",
            is_done: false,
            is_confirm: false,
            is_delete: false,
          },
          beforeUpdate : null,
          isAuthor : true,
          employees : [],
          finalDate: {date:null},
          comments: [],
        }
      },
      methods:{
        notifyVue(type,message) {
          this.$notify({
            component: NotificationTemplate,
            icon: "tim-icons icon-bell-55",
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: type,
            message:message,
            timeout: 1500
          });
        },
        async getTicket(id){
          await axios
            .get(url + 'tickets/' + id + '/',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.ticket = response.data.result[0];
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        },
        async getEmployees(){
          await axios
            .get(url + 'employees-short/',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.employees = response.data.result;
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        },
        async getComments(id){
          await axios
            .get(url + 'comments/' + id + '/',
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.comments = response.data.result;
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
            .catch((error) => {
              this.notifyVue('danger',error);
            });
        },
        getCurrentTime(){
          const today = new Date();
          return today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate() + ' ' + today.getHours() + ':' + today.getMinutes() + ':' + today.getSeconds();
        },
        getStatus(){
          if (this.ticket['is_done']){
            return "info";
          }
          const today = new Date();
          const doneBefore = new Date(this.ticket['done_before'].split('-').join('/'));
          const diffTime = doneBefore - today;
          const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
          if (this.ticket['done_before'] === null || diffDays >= 1){
            if (this.ticket['priority'] === "danger"){return "danger";}
            if (this.ticket['priority'] === "warning"){return "warning";}
            if (this.ticket['priority'] === "normal"){
              return "success";}
            if (this.ticket['priority'] === "not-important"){return "info";}
          }
          if (diffDays < 0){
            return "danger";
          }
          else if (diffDays < 1){
            return "warning";
          }
        },
        updateTicket(ticket, action){
          const data = [];
          data[0] = ticket;
          axios
            .put(url + 'update-tickets/',
              {data: data},
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error !== ''){
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
              else{
                this.beforeUpdate = JSON.parse(JSON.stringify(this.ticket));
                this.status = this.getStatus();
              }
            });
          if (action !== 'read'){
            const cTime = new Date();
            const comment = {
              comment_id : 0,
              ticket_id : this.ticket['ticket_id'],
              employee_id: 0,
              date: cTime.getFullYear() + '-' + (cTime.getMonth() + 1) + '-' + (cTime.getDate()) + ' ' + cTime.getHours() + ':' + cTime.getMinutes() + ':' + cTime.getSeconds(),
              text: "System: " + this.getEmployeeName() + " " + action + " the ticket",
            };
            this.addComment(comment);
          }
        },
        getDifference(newObj, oldObj){
          const data = {
            ticket_id : newObj['ticket_id']
          };
          for (let param in newObj){
            if (JSON.stringify(newObj[param]) !== JSON.stringify(oldObj[param])){
              data[param] = newObj[param];
            }
          }
          return data;
        },
        save(){
          if (parseInt(this.ticket.ticket_id) > 0){
            const fDate = new Date(this.finalDate.date.split('-').join('/'));
            const month = (fDate.getMonth() + 1 < 10) ? "0" + (fDate.getMonth() + 1) : "" + (fDate.getMonth() + 1);
            this.ticket['done_before'] = fDate.getFullYear() + '-' + month + '-' + fDate.getDate() + ' 00:00:00';
            if (JSON.stringify(this.ticket) !== JSON.stringify(this.beforeUpdate)){
              const ticket = this.getDifference(this.ticket, this.beforeUpdate);
              this.updateTicket(ticket, "updated");
            }
          }
          else{
            if (this.getSave()){
              this.createTicket(this.ticket);
            }
          }
        },
        addComment(comment){
          if (this.comments === null){
            this.comments = [];
          }

          this.comments.push(comment);
          axios
            .post(url + 'add-comment/',
              {data: comment},
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error !== ''){
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
              else{

              }
            });
        },
        postGetting(){
          this.isAuthor = (this.ticket['employee_id_from'] == this.myEmployeeId);
          this.ticket['is_done']      = (this.ticket['is_done']      === "1");
          this.ticket['is_delete']    = (this.ticket['is_delete']    === "1");
          this.ticket['is_confirm']   = (this.ticket['is_confirm']   === "1");
          this.ticket['is_read_to']   = (this.ticket['is_read_to']   === "1");
          this.ticket['is_read_from'] = (this.ticket['is_read_from'] === "1");
          this.status = this.getStatus();
          this.finalDate.date = new Date(this.ticket['done_before'].split('-').join('/')).toLocaleDateString("en-US");
          this.beforeUpdate = JSON.parse(JSON.stringify(this.ticket));
        },
        getEmployeeName(){
          const employee = this.employees.filter(employee => parseInt(employee['employee_id']) === this.myEmployeeId);
          if (employee.length > 0){
            return employee[0]['first_name'] + " " + employee[0]['last_name'];
          }
          else{
            return "Employee Unknown"
          }
        },
        createTicket(ticket){
          ticket['employee_id_from'] = this.myEmployeeId;
          ticket['done_before'] = this.finalDate.date + ' 23:59:59';
          axios
            .post(url + 'add-tickets/',
              {data: ticket},
              {
                withCredentials:'include',
                crossDomain:true
              })
            .then((response) => {
              if (response.data.error === ''){
                this.ticket.ticket_id = parseInt(response.data.result);
                this.$route.query['ticket-id'] = this.ticket.ticket_id;
              }
              else{
                if (response.data.error === 'Session is over'){
                  setCookie('Authentication','Failed',1);
                  this.$router.push('/login');
                }
                else{
                  this.notifyVue('danger',response.data.error);
                }
              }
            })
        },
        getSave(){
          return (this.ticket['title'] !== "") && (this.ticket['text'] !== "") && (this.ticket['employee_id_to'] !== 0);
        },
      },
      created() {
        const params = this.$route.query;
        this.getEmployees();
        if (params['ticket-id'] !== "0"){
          this.getTicket(params['ticket-id']).then((res) => {
            this.getComments(params['ticket-id']);
            this.postGetting();
            if (this.myEmployeeId === parseInt(this.ticket.employee_id_from) && !this.ticket.is_read_from){
              const ticket = {
                ticket_id : this.ticket.ticket_id,
                is_read_from : "1"
              };
              this.ticket['is_read_from'] = true;
              this.updateTicket(ticket, 'read');
            }
            if (this.myEmployeeId === parseInt(this.ticket.employee_id_to) && !this.ticket.is_read_to){
              const ticket = {
                ticket_id : this.ticket.ticket_id,
                is_read_to : "1"
              };
              this.ticket['is_read_to'] = true;
              this.updateTicket(ticket,'read');
            }
          });
        }
        else{
        }
      }
    }
</script>

<style scoped>

</style>
